import { Component, computed, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TopBar } from './_components/top-bar/top-bar';
import { MsalService } from '@azure/msal-angular';
import { filter, map, startWith } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { routingConstants } from './_constants/routing-constants.const';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TopBar],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  public showTopBar = computed(() => !this.currentUrl().startsWith('/' + routingConstants.login));

  private readonly authService = inject(MsalService);
  private readonly router = inject(Router);

  public ngOnInit(): void {
    this.authService.handleRedirectObservable({
      navigateToLoginRequestUrl: true
    }).subscribe();
  }

  private currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => event.url),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );
}
